export default {
  id: 155,
  title: 'Target #155 - Snakes & Ladders',
  url: 'https://cssbattle.dev/play/155',
  colors: ['#6592CF', '#060F55'],
  solution:
    '<p a><p b><style>[a],[b]{left:120}body{background:#6592cf}p{width:100;height:100;background:#060f55;position:fixed}[a]{top:44;width:30;height:300;border-radius:1in;box-shadow:130px 0 #060f55}[b]{top:104;width:160;height:30;box-shadow:0 60px #060f55,0 120px #060f55}</style>',
}
